export const arrayMin = data => Math.min(...data);